import React, { useState } from "react";
import ReactTooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import * as styles from "./Tooltip.module.scss";
import Icon from "@app/components/Icon";
import PropTypes from "prop-types";

const Tooltip = ({
	content,
	onToggle,
	placement = "bottom",
	delay = 0,
	icon = {
		default: "circle-info",
		active: "circle-info-fill",
		size: 16,
	},
	trigger = "hover",
}) => {
	const [show, setShow] = useState(false);

	return (
		<OverlayTrigger
			placement={placement}
			delay={delay}
			trigger={[trigger, "focus"]}
			onToggle={(show) => {
				{
					setShow(show);
					onToggle && typeof onToggle === "function" && onToggle(show);
				}
			}}
			flip={true}
			overlay={<ReactTooltip style={{ position: "fixed" }}>{content}</ReactTooltip>}
		>
			<span className={styles["tooltip-inner"]}>
				<Icon icon={show ? icon.active : icon.default} size={icon.size} />
			</span>
		</OverlayTrigger>
	);
};

Tooltip.propTypes = {
	placement: PropTypes.oneOf(["auto", "bottom", "top", "right", "left"]),
	delay: PropTypes.number,
	icon: PropTypes.shape({
		default: PropTypes.string.isRequired,
		active: PropTypes.string.isRequired,
		size: PropTypes.number,
	}),
	content: PropTypes.element.isRequired,
	onToggle: PropTypes.func,
	trigger: PropTypes.oneOf(["hover", "click"]),
};

export default Tooltip;
